import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { reportsApi } from '@/lib/api/reports.api';

import type { ReportQuery, CreateReportDto } from '@repo/shared-types';

export function useReports(query: Partial<ReportQuery> = {}) {
  return useQuery({
    queryKey: ['reports', query],
    queryFn: () => reportsApi.getReports(query),
  });
}

export function useReport(id: string | undefined) {
  return useQuery({
    queryKey: ['reports', id],
    queryFn: () => reportsApi.getReport(id!),
    enabled: !!id,
  });
}

export function useCreateReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateReportDto) => reportsApi.createReport(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reports'] });
    },
  });
}

export function useDeleteReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => reportsApi.deleteReport(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reports'] });
    },
  });
}
